import * as React from 'react';
import { rootGroupCode } from 'entities/RootGroup';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import CurrentUser from 'auth/CurrentUser';
import ErrorReporter from 'app/components/ErrorReporter';
import GroupByCodeFetcher from 'groups/containers/GroupByCodeFetcher';
import TitleHeader from 'components/TitleHeader';
// @ts-ignore
import TriggerComposerButton from 'chat/components/TriggerComposerButton';
// @ts-ignore
import View from 'components/View';

import './styles/ChatLearnMore.scss';

type Props = {
  groupCode: string;
};

function ChatLearnMore({ groupCode }: Props) {
  const currentUser = CurrentUser.getUser();
  const title = 'Direct, reliable messaging. Built for education.';
  const subtext = currentUser.isUnderage()
    ? 'Never miss a class announcement. Once you turn 13, you can reply to messages you receive.'
    : 'Reach individuals and groups by text, app, web, and email.';

  if (groupCode === rootGroupCode) {
    return (
      <View className="ChatLearnMore">
        <TitleHeader
          flush
          image={require('assets/images/chat/ChatLearnMore/apps.svg')}
          subtext={subtext}
          title={title}
        />
      </View>
    );
  }

  return (
    <GroupByCodeFetcher groupCode={groupCode}>
      {({ group, loading, error }) => {
        if (loading) {
          return <CenteredLoadingIndicator />;
        }

        if (error) {
          return <ErrorReporter error="ChatLearnMore - failed to fetch group" />;
        }

        const isGroupOwner =
          group && group.owners.some(owner => owner.user.uuid === currentUser.getUuid());

        const composeButton = (
          <TriggerComposerButton
            hideAnnouncements={!isGroupOwner}
            label="Get started"
            level="secondary"
            className="ChatLearnMore-action"
          />
        );

        return (
          <View className="ChatLearnMore">
            <TitleHeader
              action={currentUser.canChat() && composeButton}
              flush
              image={require('assets/images/chat/ChatLearnMore/apps.svg')}
              subtext={subtext}
              title={title}
            />
          </View>
        );
      }}
    </GroupByCodeFetcher>
  );
}

export default ChatLearnMore;
